import {memo} from 'react';

import styled, {css} from 'styled-components';

import PieButton from '~/shared/theme/pie/PieButton/PieButton';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import CloseIcon from '~/assets/images/icons/pie/functionalityCloseSmall.svg?react';
import {media} from '~/shared/theme/media';

const hiddenOnMobileStyle = css<{hideOnMobile?: boolean}>`
  ${({hideOnMobile}) => hideOnMobile && css`
    display: none;
    ${media.minLargeMobile`
      display: flex;
    `}
  `}
`;

const CloseButton = styled(PieButton).attrs({
  variant: 'secondarySmall',
  iconButton: true,
})<{hideOnMobile?: boolean}>`
  ${hiddenOnMobileStyle}
  z-index: 5;
  position: absolute;
  top: 24px;
  ${flipOnLTR`
    left: 24px
  `}
`;

type PieCloseButtonProps = {
  onClick: () => void;
  hideOnMobile?: boolean;
  dataTestId?: string;
};

const PieCloseModalButton = ({onClick, hideOnMobile, dataTestId}: PieCloseButtonProps) => (
  <CloseButton onClick={onClick} hideOnMobile={hideOnMobile} data-test-id={dataTestId}>
    <CloseIcon />
  </CloseButton>
);

export default memo(PieCloseModalButton);
